import axios from "../../config/axiosConfig";
import {
  CREATE_PURCHASE_ORDER,
  DELETE_PURCHASE_ORDER,
  GET_PURCHASE_ORDERS_PAGE,
  GET_PURCHASE_ORDERS,
  PURCHASE_ORDER_REQUEST,
  PURCHASE_ORDER_REQUEST_SUCCESS,
  PURCHASE_ORDER_REQUEST_FAILURE,
  UPDATE_PURCHASE_ORDER
} from "../types";

export const getPurchaseOrdersWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_ORDER_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id,Account_Id,Lot_Id,Grade_Id'
      };
      return axios.get("/purchase-order/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PURCHASE_ORDERS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_ORDER_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_ORDER_REQUEST_FAILURE, error: error.message });
    }
  };
};


export const getPurchaseOrders = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_ORDER_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/purchase-order/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PURCHASE_ORDERS, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_ORDER_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_ORDER_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getPurchaseOrderById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_ORDER_REQUEST });
    
      return axios.get(`/purchase-order/get/${id}`).then((response) => {
        dispatch({ type: PURCHASE_ORDER_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_ORDER_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_ORDER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getAllPurchaseOrdersGradeofPartyItem = (otherparams) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (otherparams) {
        params = { ...params, ...otherparams };
      }
      // dispatch({ type: PURCHASE_ORDER_REQUEST });
      return axios.get("/purchase-order/getAllPurchaseOrdersGradeofPartyItem", { params }).then((response) => {
        // dispatch({ type: PURCHASE_ORDER_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        // dispatch({ type: PURCHASE_ORDER_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      // dispatch({ type: PURCHASE_ORDER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getPurchaseOrdersByRange = (bookId, billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        bookId, billId, from, to
      };
      
      const response = await axios.get("/purchase-order/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const createPurchaseOrder = (purchaseBillReturn) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: PURCHASE_ORDER_REQUEST });
      const newPurchaseOrder = {
        ...purchaseBillReturn
      };
      return axios.post("/purchase-order/add", newPurchaseOrder,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_PURCHASE_ORDER, payload: response.data });
        } else {
          dispatch({
            type: PURCHASE_ORDER_REQUEST_FAILURE,
            error: "Purchase Order create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_ORDER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_ORDER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updatePurchaseOrder = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_ORDER_REQUEST });
      const { auth } = getState();
      return axios.put("/purchase-order/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_PURCHASE_ORDER,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: PURCHASE_ORDER_REQUEST_FAILURE,
            error: "Purchase Order update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_ORDER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_ORDER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deletePurchaseOrder = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_ORDER_REQUEST });
      return axios.delete(`/purchase-order/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_PURCHASE_ORDER, id: id });
          const include = ['id', 'Order_No', 'P_Order_No', 'Book_Id', 'Date', 'Account_Id', 'Lot_Id', 'Grade_Id', 'Amount', 'Net_Total', 'Order_Status'].join(',');
          const searchCols = ['Order_No', 'P_Order_No'].join(',');
          const { inventory: { purchaseOrder: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getPurchaseOrdersWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_ORDER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_ORDER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updatePurchaseOrderTransaction = (id, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      return axios.put("/purchase-order-transaction/update", { id, data },
        { params: { userId: auth.user?.id } }
      ).then((response) => {
        return response;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};